module.exports = __webpack_public_path__ + "f70e3ee7ae4d136e5cf0f404df00be03.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/icon-newtab.svg
// module id = 6
// module chunks = 0